// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".separateOrderText[data-v-7c29daa0]{color:#413dff;font-size:17px;font-weight:600;line-height:20px;margin-bottom:24px;text-align:center}.novikov .separateOrderText[data-v-7c29daa0]{color:#ee1623}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
